var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicpayFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.43 191.366v103.101h67.214c14.839 0 28.399-5.888 38.186-15.455 9.405-9.194 15.281-21.919 15.281-36.096 0-14.178-5.876-26.903-15.281-36.096-9.787-9.567-23.347-15.454-38.186-15.454H112.43zM44 441V191.366h68.308v-63.869h67.336c31.934 0 61.276 12.827 82.596 33.667 21.381 20.902 34.739 49.729 34.739 81.752 0 32.024-13.358 60.849-34.739 81.751-21.32 20.842-50.662 33.669-82.596 33.669H112.43V441H44zM358.011 92.67v88.275h88.276V92.669h-88.276zm21.67 21.669h44.937v44.937h-44.937v-44.937zM336.342 71h131.614v131.614H336.342V71",
    fill: "#21C25E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicpayFlat);
export default __webpack_public_path__ + "static/media/picpay-flat.72efe3650db9f997f1ea234fda87f0fc.svg";
export { ForwardRef as ReactComponent };